import { Action, Reducer, Dispatch } from 'redux';
import { CoreInstanceSettings } from '../models/CoreInstanceSettings';
import InstanceClient from '../services/InstanceClient';
import StatusCode from '../util/StatusCode';
import { EmptyRequestState } from '../models/RequestState';

export enum InstanceConfigActionType {
    GET_INSTANCECONFIG = 'GET_INSTANCECONFIG',
    UPDATE_INSTANCECONFIG = 'UPDATE_INSTANCECONFIG'
}

export interface InstanceConfigState {
    settings?: CoreInstanceSettings
    updateStatus: EmptyRequestState
}

interface GetInstanceConfigAction extends Action<InstanceConfigActionType.GET_INSTANCECONFIG> {
    instanceSettings: CoreInstanceSettings
}
interface UpdateInstanceConfigAction extends Action<InstanceConfigActionType.UPDATE_INSTANCECONFIG> {
    updateStatus: EmptyRequestState
}


type InstanceConfigAction = GetInstanceConfigAction | UpdateInstanceConfigAction;

const initialState: InstanceConfigState = {
    settings: undefined,
    updateStatus: { code: StatusCode.NONE }
};

export const getInstanceSettings = () => (dispatch: Dispatch<GetInstanceConfigAction>) => {
    const url = '/api/core/instanceSettings';
    InstanceClient.get<CoreInstanceSettings>(url)
        .then(res => {
            dispatch({
                type: InstanceConfigActionType.GET_INSTANCECONFIG,
                instanceSettings: res.data,
            })
        });
};

export const updateInstanceSettings = (settings: CoreInstanceSettings) => (dispatch: Dispatch<UpdateInstanceConfigAction>) => {    
    dispatch({ type: InstanceConfigActionType.UPDATE_INSTANCECONFIG, updateStatus: { code: StatusCode.PENDING } })

    return InstanceClient.put(`api/core/instanceSettings`, settings)
        .then(response => {
            dispatch({ type: InstanceConfigActionType.UPDATE_INSTANCECONFIG, updateStatus: { code: StatusCode.COMPLETE } });
            return response;
        })
        .catch(error => {
            dispatch({ type: InstanceConfigActionType.UPDATE_INSTANCECONFIG, updateStatus: { code: StatusCode.ERROR, error } });
            return null;
        })
        .finally(() => {
            setTimeout(() => {
                dispatch({ type: InstanceConfigActionType.UPDATE_INSTANCECONFIG, updateStatus: { code: StatusCode.NONE } })
            }, 1500)
        });
}

export const resetUpdateInstanceSettings = () => (dispatch: Dispatch<UpdateInstanceConfigAction>) => {
    dispatch({ type: InstanceConfigActionType.UPDATE_INSTANCECONFIG, updateStatus: { code: StatusCode.NONE } });
}
    
export const reducer: Reducer<InstanceConfigState, InstanceConfigAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case InstanceConfigActionType.GET_INSTANCECONFIG:
            return {
                ...state,
                settings: action.instanceSettings
            }
        case InstanceConfigActionType.UPDATE_INSTANCECONFIG:
            return {
                ...state,
                updateStatus: action.updateStatus,
            }
        default:
            return state;
    }
}